"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addPaymentsWidgets = void 0;
var PaymentCardList_1 = require("./PaymentCardList");
var PaymentChoiceWidget_1 = require("./PaymentChoiceWidget");
var PaymentFailureAlertWidget_1 = require("./PaymentFailureAlertWidget");
var PaymentPanelWidget_1 = require("./PaymentPanelWidget");
var PaymentProcessingWidget_1 = require("./PaymentProcessingWidget");
var PaymentsHeaderWidget_1 = require("./PaymentsHeaderWidget");
var CurrencyAmountDisplayWidget_1 = require("./CurrencyAmountDisplayWidget");
var AnnualPaymentPanelWidget_1 = require("../annual/motor/AnnualPaymentPanelWidget");
var NewMonthlyPayWidget_1 = require("./NewMonthlyPayWidget");
var CancelPageWithInFlightBox_1 = require("./CancelPageWithInFlightBox");
var UpfrontInterestAmountDisplayWidget_1 = require("./UpfrontInterestAmountDisplayWidget");
var RenewalCardDetailsPanelWidget_1 = require("./RenewalCardDetailsPanelWidget");
var RenewalDirectDebitDetailsPanelWidget_1 = require("./RenewalDirectDebitDetailsPanelWidget");
var RenewalDirectDebitHeadsUpWidget_1 = require("./RenewalDirectDebitHeadsUpWidget");
var OldMonthlyPayWidget_1 = require("./OldMonthlyPayWidget");
var addPaymentsWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentCardList",
        component: PaymentCardList_1.PaymentCardList
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentChoice",
        component: PaymentChoiceWidget_1.PaymentChoiceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentFailureAlert",
        component: PaymentFailureAlertWidget_1.PaymentFailureAlertWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentPanelOutput",
        component: PaymentPanelWidget_1.PaymentPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalCardDetailsOutput",
        component: RenewalCardDetailsPanelWidget_1.RenewalCardDetailsPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalDirectDebitDetailsPanelOutput",
        component: RenewalDirectDebitDetailsPanelWidget_1.RenewalDirectDebitDetailsPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalDirectDebitHeadsUpOutput",
        component: RenewalDirectDebitHeadsUpWidget_1.RenewalDirectDebitHeadsUpWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentProcessingOutput",
        component: PaymentProcessingWidget_1.PaymentProcessingWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "paymentsHeader",
        component: PaymentsHeaderWidget_1.PaymentsHeaderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "currencyAmountDisplay",
        component: CurrencyAmountDisplayWidget_1.CurrencyAmountDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "annualPaymentPanelOutput",
        component: AnnualPaymentPanelWidget_1.AnnualPaymentPanelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "newMonthlyPay",
        component: NewMonthlyPayWidget_1.NewMonthlyPayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "cancelPageWithInFlightBox",
        component: CancelPageWithInFlightBox_1.CancelPageWithInFlightBox
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "upfrontInterestAmountDisplayOutput",
        component: UpfrontInterestAmountDisplayWidget_1.UpfrontInterestAmountDisplayWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "oldMonthlyPayWidget",
        component: OldMonthlyPayWidget_1.OldMonthlyPayWidget
    });
};
exports.addPaymentsWidgets = addPaymentsWidgets;
//# sourceMappingURL=index.js.map